<template>
    <nav class="py-8">
        <div class="start flex items-center gap-2 !py-0">
            <span class="text-sm">
                <NuxtLink
                    to="/blog"
                    class="flex items-center gap-1 !text-gray-500 !no-underline hover:!text-gray-700"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-5"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
                        />
                    </svg>

                    {{ t('blog') }}
                </NuxtLink>
            </span>

            <!-- Arrow right icon -->
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-4"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
            </svg>

            <span class="text-sm font-semibold text-blue-500">
                {{ article.title }}
            </span>
        </div>
    </nav>
</template>

<script setup lang="ts">
import type { BlogArticle } from '~/types/blog'

defineProps({
    article: {
        type: Object as PropType<BlogArticle>,
        required: true,
    },
})

const { t } = useI18n()
</script>

<i18n lang="yaml">
en:
    blog: 'Блог'
bg:
    blog: 'Блог'
</i18n>
